module.exports = __webpack_public_path__ + "static/media/liyanan.070e9514.png";